import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class EcommerceSharedService {
  feesCalculations: Fees[];
  constructor(private http: HttpClient,
    private datePipe: DatePipe) { }

  //#region HTTP Requests

  getRequests(path, headerRequest) {
    return this.http.get(path, headerRequest);
  }

  postRequests(path, body = {}, headerRequest = {}) {
    return this.http.post(path, body, headerRequest);
  }

  putRequests(path, body = {}, headerRequest = {}) {
    return this.http.put(path, body, headerRequest);
  }

  //#endregion

  //#region Order & Payment methods

  paymentStatus(orderStatus, paymentStatus, orderId, paymentId, headerRequest) {
    return this.getRequests(`/Quickpay/update/1/${orderId}/${orderStatus}/${paymentId}/${paymentStatus}`, headerRequest);
  }

  getOrder(orderId: number, headerRequest): any {
    return this.http.get<Order>(`/orders/${orderId}`, headerRequest)
  }

  //#endregion

  //#region Format Money and Currency

  formatNumberToMoney(value, currency) {
    if (value) {
      return `${currency}  ${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
    }
  }

  //#endregion

  //#region  Prepare Email Template

  getItems(order: Order, feesCalculations?: Fees[]) {
    let courses: string= '';
    let adminItems: string ='';
    let contentHTML = `<tr style="background:#eeeeee;text-align: center; height: 30px;">
    <th>Product</th>
    <th>Price</th>
    <th>Quantity</th>`;
    if (
      order.taxAmount > 0 &&
      (order.shippingAddress.countryId === "SE" ||
        (order.shippingAddress.countryId !== "SE" &&
          order.registrationType === 1))
    )
      contentHTML += `<th>Moms/VAT %</th>`;
    contentHTML += `<th>Total</th>
  </tr>`;
    order.orderItems.forEach((item) => {
      courses = courses? courses:'' + `
      <li>
      ${item.productDate
        ? this.datePipe.transform(
          new Date(
            item.productDate
          ).toLocaleDateString(),
          "longDate"
        )
        : ""}  ${item.productName}
      </li>
      `;

      adminItems += `<tr>
        <td>${item.productId} </td>
        <td style="text-align: left"> ${item.productDate
          ? this.datePipe.transform(
            new Date(
              item.productDate
            ).toLocaleDateString(),
            "longDate"
          )
          : ""}  ${item.productName} </td>
        <td style="text-align: left"> ${order.orderTotalString} </td>
        <td style="text-align: right"> ${item.quantity} </td>
      </tr>`

      contentHTML += `<tr>
      <td style="color: #333; border: #eeeeee  solid 1px;    text-align: center;">
      ${item.productDate
          ? this.datePipe.transform(
            new Date(
              item.productDate
            ).toLocaleDateString(),
            "longDate"
          )
          : ""
        }  ${item.productName}`;
      if (item && item.variationOptions && item.variationOptions.length > 0) {
        contentHTML += `<ul class="list-group" style="text-align:left; margin-left:40px;">`;
        item.variationOptions.forEach((opt) => {
          contentHTML += `<li class="list-group-item"> <span>${opt.optionName
            ? opt.optionName.charAt(0).toUpperCase() + opt.optionName.slice(1)
            : opt.optionName
            }:</span> ${opt.value} </li>`;
        });

        contentHTML += `</ul>`;
      }
      contentHTML += `</td>
      <td style="color: #333; border: #eeeeee  solid 1px;    text-align: right;">
        ${item.productPriceString} </td>
      <td style="color: #333; border: #eeeeee  solid 1px;    text-align: center;">
        ${item.quantity}</td>`;
      if (
        item.taxPercent > 0 &&
        (order.shippingAddress.countryId === "SE" ||
          (order.shippingAddress.countryId !== "SE" &&
            order.registrationType === 1))
      )
        contentHTML += `<td style="color: #333; border: #eeeeee  solid 1px;    text-align: center;">
          ${item.taxPercent ? +item.taxPercent * 100 : 0
          } %</td>`;
      contentHTML += `<td style="color: #333; border: #eeeeee  solid 1px;    text-align: right;">
        ${item.totalString}</td>

    </tr>`;
    });

    // Fees ----------------------------------------
    if (feesCalculations.length != 0)
      feesCalculations.forEach((additionalFee) => {
        if (additionalFee.feesValue && additionalFee.feesValue != 0)
          contentHTML += `<tr style="text-align: right;">
                          <td colspan="4"><b>${additionalFee.feesName}</b></td>
                          <td style="text-align: right;">${additionalFee.feesValueString}</td>
                          </tr>`;
      });

    // Discount ----------------------------------------
    if (order.discountAmount && order.discountAmount != 0)
      contentHTML += `<tr style="text-align: right;">
                      <td colspan="4"><b>Discount</b></td>
                      <td style="text-align: right;">${order.discountAmountString}</td>
                      </tr>`;

    // Subtotal with   Discount ----------------------------------------
    if (
      order.subTotalWithDiscount &&
      order.subTotalWithDiscount !== 0 &&
      order.subtotal != order.subTotalWithDiscount
    )
      contentHTML += ` <tr style="text-align: right;">
              <td colspan="4"><b>Subtotal with discount</b></td>
              <td style="text-align: right;">${order.subtotalWithDiscountString}</td>
            </tr>`;

    // Tax (Moms) ----------------------------------------
    if (
      order.taxAmount > 0 &&
      (order.shippingAddress.countryId === "SE" ||
        (order.shippingAddress.countryId !== "SE" &&
          order.registrationType === 1))
    )
      contentHTML += `
                    <tr style="text-align: right;">
                    <td colspan="4"><b>Moms/VAT</b></td>
                    <td style="text-align: right;">${order.taxAmountString}</td>
                    </tr>`;
    return { items: contentHTML, courses: courses, adminItems: adminItems }
  }


  sendEmail(order: Order, templateId: string, siteId, emailReceviers: string[], receiverType : EmailRecieverType, feesCalculations?, name?) {
    const customizedData = this.getItems(order, feesCalculations);
    let items = customizedData.items;
    if(receiverType === EmailRecieverType.Admin){
      items = customizedData.adminItems;
    }

    const notificationAPIData = {
      NotificationType : 3,
      SendVia :2,
      SendValue: emailReceviers,
      Severity:1,
      emailSenderVM: {
        Emails: emailReceviers,
        TemplateId: templateId,
        isHtml: true, attachment: null,
        Params: [
          { Param: '[Name]', Value: !name ? order.customerName : name },
          { Param: '[Date]', Value: this.datePipe.transform(new Date().toLocaleDateString(), 'dd/MM/yyyy') },
          { Param: '[InvoiceNo]', Value: order.id },
          { Param: '[OrderTotal]', Value: order.orderTotalString },
          { Param: '<tr><td>[Items]</td></tr>',Value: items },
          { Param: '[CompanyOrName]', Value: order.registrationType === 1 ? order.nameOnReceipt : order.company },
          { Param: '[FullAddress]', Value: this.getAddress(order) },
          { Param: '[purchaserName]', Value: order.customerName },
          { Param: '[courseName]', Value: customizedData.courses },
          { Param: '[Email]', Value: order.customerEmail },
          { Param: '[Phone]', Value: order.customerName ? order.customerName : '' },

        ]}
  }

    return this.http.post(`/Notification/send`, notificationAPIData, { headers: new HttpHeaders({ 'siteId': siteId + '' }), })
      .pipe();
  }

  getCountryName(countryId,shipableContriesSelected) {
    var country = shipableContriesSelected.find(x => x.value == countryId);
    return country ? country.text : '';
  }

  getAddress(order) {
    var contentHTML = '';
    contentHTML += `${order.useBillingAsShippingAddress
      ? order.shippingAddress.addressLine1
      : order.billingAddress.addressLine1 ? order.billingAddress.addressLine1 : ''
      }`;
    if (
      order.shippingAddress.addressLine2Only &&
      order.useBillingAsShippingAddress
    ) { contentHTML += `<br> ${order.shippingAddress.addressLine2Only}`; }
    else if (
      order.billingAddress.addressLine2Only &&
      !order.useBillingAsShippingAddress
    ) { contentHTML += `<br> ${order.billingAddress.addressLine2Only}`; }

    if (
      (order.shippingAddress.zipCode ||
        order.shippingAddress.cityName) &&
      order.useBillingAsShippingAddress
    )
      contentHTML += `<br> ${order.shippingAddress.zipCode
        ? order.shippingAddress.zipCode
        : ""
        } ${order.shippingAddress.cityName
          ? order.shippingAddress.cityName
          : ""
        }<br>`;

    if (
      (order.billingAddress.zipCode ||
        order.billingAddress.cityName) &&
      !order.useBillingAsShippingAddress
    )
      contentHTML += `<br> ${order.billingAddress.zipCode
        ? order.billingAddress.zipCode
        : ""
        } ${order.billingAddress.cityName
          ? order.billingAddress.cityName
          : ""
        }<br>`;

    if (
      order.shippingAddress.stateOrProvinceName &&
      order.useBillingAsShippingAddress
    )
      contentHTML += `${order.shippingAddress.stateOrProvinceName}, `;

    if (
      order.billingAddress.stateOrProvinceName &&
      !order.useBillingAsShippingAddress
    )
      contentHTML += `${order.billingAddress.stateOrProvinceName}, `;

    contentHTML += `${order.useBillingAsShippingAddress
      ? order.shippingAddress.countryName
        ? order.shippingAddress.countryName
        : ""
      : order.billingAddress.countryName
        ? order.billingAddress.countryName
        : ""
      }`;
    return contentHTML;
  }

  //#endregion
}


export interface Order {
  id: number;
  customerId: number;
  useBillingAsShippingAddress?: boolean;
  customerName: string;
  customerEmail: string;
  createdOn: Date;
  orderStatusString: string;
  orderStatus: number;
  subtotal: number;
  discountAmount: number;
  subTotalWithDiscount: number;
  taxAmount: number;
  shippingAmount: number;
  orderTotal: number;
  shippingMethod: string;
  paymentMethod: string;
  paymentFeeAmount: number;
  subtotalString: string;
  discountAmountString: string;
  subtotalWithDiscountString: string;
  taxAmountString: string;
  shippingAmountString: string;
  paymentFeeAmountString: string;
  orderTotalString: string;
  shippingAddress: Address;
  billingAddress: Address;
  orderItems: OrderItem[];
  orderNote?: string;
  totalFees: number;
  shipableContries: Country[];
  company?: string;
  registrationType?: number;
  nameOnReceipt?: string;
  eventDate?: Date;
  currency: string
};

export interface Address {
  userAddressId: number;
  contactName: string;
  phone: string;
  email?: string;
  addressLine1: string;
  addressLine2: string;
  addressLine2Only: string;
  zipCode: string;
  stateOrProvinceId: number;
  stateOrProvinceName: string;
  cityName: string;
  countryId: string;
  countryName: string;
  isDistrictEnabled: boolean;
  isZipCodeEnabled: boolean;
  isCityEnabled: boolean
};

export interface OrderItem {
  id: number;
  productId: number;
  productName: string;
  productDate: Date;
  productImage?: string;
  productPrice: number;
  quantity: number;
  shippedQuantity: number;
  taxAmount: number;
  taxPercent: number;
  discountAmount: number;
  additionalDetails: string;
  planName?: string;
  total: number;
  taxIncludedAmount: number;
  rowTotal: number;
  taxAmountString: string;
  productPriceString: string;
  discountAmountString: string;
  totalString: string;
  taxIncludedAmountString: string;
  rowTotalString: string;
  productAdditionalFees: [];
  variationOptions?: VariationOptions[]
  additionalDetailsArray?: any[]
  showAdditionalDetails?: boolean;
}

export interface VariationOptions {
  optionName?: string;
  value?: string
}

export interface Country {
  disabled: boolean;
  group?: any;
  selected: boolean;
  text: string;
  value: string
}

export interface Fees {
  feesValue?: number;
  feesName?: string;
  feesValueString?: string;
  feesType?: number;
}

export enum EmailRecieverType {
  customer = 1,
  Admin = 2,
  OrderMaker = 3
  }

